import React, { ReactElement } from 'react';
import { Badge } from 'react-bootstrap';
import i18next from 'i18next';
import { TrainingPlanStatus } from '../../../../../shared/utils/enums';
import { formatDate } from "../../../util/date-utils";

type TrainingPlanStatusBadgeProps = {
  status: TrainingPlanStatus;
  endDate?: string;
  unpublishedDate?: string;
};

const TrainingPlanStatusBadge = ({ status, endDate, unpublishedDate, }: TrainingPlanStatusBadgeProps): ReactElement | null => {
  switch (status) {
    case TrainingPlanStatus.DRAFT:
      return (
        <Badge pill bg="warning">
          {i18next.t('trainingPlan.status.draft')}
        </Badge>
      );

    case TrainingPlanStatus.PUBLISHED:
      return (
        <Badge pill bg="success" className="text-white">
          {i18next.t('trainingPlan.publishUntil')}{' '}
          {formatDate(endDate)}
        </Badge>
      );

    case TrainingPlanStatus.UNPUBLISHED:
      return (
        <Badge pill bg="warning" className="text-white">
          {i18next.t('trainingPlan.unpublishedSince')}{' '}
          {formatDate(unpublishedDate)}
        </Badge>
      );

    default:
      return null;
  }
};

export default TrainingPlanStatusBadge;
